/**
 * Azure TTS configuration using environment variables
 * This provides better security by not hardcoding API keys in the codebase
 */
export const azureConfig = {
  subscriptionKey: import.meta.env.VITE_AZURE_SUBSCRIPTION_KEY || '',
  backupKey: import.meta.env.VITE_AZURE_BACKUP_KEY || '',
  region: import.meta.env.VITE_AZURE_REGION || 'eastus',
  endpoint: import.meta.env.VITE_AZURE_ENDPOINT || 'https://eastus.api.cognitive.microsoft.com/'
};